import React, {forwardRef, useImperativeHandle} from 'react'
import PropTypes from 'prop-types'

import {Section} from "../../02-Molecules/Section/Section"
import {FormRadios} from "../../01-Atoms/FormRadios/FormRadios";
import {FormInput} from "../../01-Atoms/FormInput/FormInput";

/**
 * Primary UI component for user interaction
 */
export const SectionReasonForDonating = forwardRef(({ collapsed, heading, headingLarge, options, required, sectionId, recap, staticText, tracking, trackEvent, validationHash, values,  ...props }, ref) => {
  const isValid = () => true

  // If options is empty, use staticText (populated from settings page)
  if(options.length === 0) {
    options = staticText.reasons.options
  }


  useImperativeHandle(ref, () => ({
    isValid: ()  => isValid(),
  }))

  /**
   * Handle any form changes.
   *
   * @param {string} name
   *   The name of the value that changed
   * @param {string} value
   *   The new value
   */
  const handlerInputChange = (name, value) => {
    props.onInputChange(name, value)
  }

  return (
    <Section tracking={tracking} trackEvent={trackEvent} collapsed={collapsed} heading={heading} headingLarge={headingLarge} sectionId={sectionId}>
      <div>
        <FormRadios
          label={staticText.reasons.options_heading}
          name={'payment_reason'}
          options={[...options.map(option => {
            return { value: option, label: option }
          }), { value: 'other', label: 'Other' }]}
          required={required}
          onInputChange={handlerInputChange}
          value={values.payment_reason}
          validationHash={validationHash}
        />

        {values.payment_reason === 'other' &&
        <FormInput
          label={'Other'}
          value={values.payment_reason_other}
          name={'payment_reason_other'}
          type={'text'}
          onInputChange={handlerInputChange}
          validationHash={validationHash}
        />
        }
      </div>
    </Section>
  )
})

SectionReasonForDonating.propTypes = {
  collapsed    : PropTypes.bool,
  required     : PropTypes.bool,
  heading      : PropTypes.string,
  headingLarge : PropTypes.bool,
  sectionId    : PropTypes.string,
  onInputChange: PropTypes.func,
  staticText   : PropTypes.shape({
    reasons: PropTypes.shape({
      text_before    : PropTypes.string,
      options_heading: PropTypes.string,
      text_after     : PropTypes.string,
    })
  }),
  tracking: PropTypes.shape({
    id  : PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    type: PropTypes.oneOf(['entry', 'exit', 'entry_exit'])
  }),
  trackEvent: PropTypes.func,
  values: PropTypes.shape({
    payment_reason      : PropTypes.string,
    payment_reason_other: PropTypes.string,
  }),
  options: PropTypes.arrayOf(PropTypes.string),
  validationHash: PropTypes.string,
}

SectionReasonForDonating.defaultProps = {
  collapsed: false,
  recap    : false,
  required : false
}
